import React from 'react';

const Check = (props) => (
  <svg
    data-name="Group 148557"
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    {...props}
  >
    <circle
      data-name="Ellipse 2156"
      cx={9}
      cy={9}
      r={9}
      transform="translate(3 3)"
      fill="#5e70cc"
    />
    <g data-name="Group 148551" fill="none">
      <path data-name="Path 197979" d="M0 0h24v24H0Z" />
      <circle
        data-name="Ellipse 2155"
        cx={9}
        cy={9}
        r={9}
        transform="translate(3 3)"
      />
      <path
        data-name="Path 197980"
        d="m9 12 2 2 4-4"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </g>
  </svg>
);

export default Check;
